const REVIEWS = [
  {
    name: '夜风',
    role: '热血漫爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20avatar%20of%20a%20young%20asian%20man%20smiling%2C%20warm%20natural%20lighting%2C%20clean%20background%2C%20friendly%20illustration%20style&width=200&height=200&seq=avatar-01&orientation=squarish',
    text: '标签分类特别清楚，找热血漫画基本一步到位，更新也很快，追更体验很舒服。',
  },
  {
    name: '柚子',
    role: '少女漫读者',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20avatar%20of%20a%20young%20asian%20woman%20with%20gentle%20smile%2C%20soft%20warm%20lighting%2C%20clean%20background%2C%20cute%20illustration%20style&width=200&height=200&seq=avatar-02&orientation=squarish',
    text: '完结作品专区太友好了，可以直接把喜欢的少女漫一次追完，评分也很有参考价值。',
  },
  {
    name: '阿哲',
    role: '搞笑漫爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20avatar%20of%20a%20young%20man%20in%20glasses%20laughing%2C%20warm%20lighting%2C%20clean%20background%2C%20playful%20illustration%20style&width=200&height=200&seq=avatar-03&orientation=squarish',
    text: '汉化组专区内容很精品，翻译质量稳定，找搞笑作品再也不用到处乱翻了。',
  },
  {
    name: '小满',
    role: '少年漫读者',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20avatar%20of%20a%20young%20asian%20woman%20with%20short%20hair%2C%20confident%20smile%2C%20warm%20tone%2C%20clean%20background%2C%20modern%20illustration%20style&width=200&height=200&seq=avatar-04&orientation=squarish',
    text: '界面干净没有杂七杂八的广告，按标签筛选又快又准，已经在这里追了好几部了。',
  },
];

export default function Testimonials() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary-600">Word of Mouth</span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            读者们怎么说
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            来自真实读者的使用体验，也是我们不断优化分类与更新体验的动力。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {REVIEWS.map((r) => (
            <figure
              key={r.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <div className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-800">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <img
                  src={r.avatar}
                  alt={`${r.name}头像`}
                  className="h-10 w-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-bold text-foreground-900">{r.name}</p>
                  <p className="text-xs text-foreground-600">{r.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}